import type { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  as?: 'div' | 'form';
}

interface CardTitleProps {
  children: ReactNode;
  centerActions?: ReactNode;
  rightActions?: ReactNode;
}

interface CardFooterProps {
  children: ReactNode;
}

function CardRoot({ children, className = '', as = 'div' }: CardProps) {
  const Component = as;

  return <Component className={`card ${className}`.trim()}>{children}</Component>;
}

function CardTitle({ children, centerActions, rightActions }: CardTitleProps) {
  return (
    <div className="card-header">
      <div className="row align-items-center w-100 g-2">
        <div className="col min-w-0">
          <h4 className="card-title m-0 text-truncate">{children}</h4>
        </div>
        {centerActions && <div className="col-auto d-flex justify-content-center">{centerActions}</div>}
        {centerActions && <div className="col min-w-0 d-flex justify-content-end">{rightActions}</div>}
        {!centerActions && rightActions && <div className="col-auto d-flex justify-content-end">{rightActions}</div>}
      </div>
    </div>
  );
}

function CardBody({ children }: { children: ReactNode }) {
  return <div className="card-body">{children}</div>;
}

function CardFooter({ children }: CardFooterProps) {
  return <div className="card-footer text-end">{children}</div>;
}

export const Card = Object.assign(CardRoot, {
  Title: CardTitle,
  Body: CardBody,
  Footer: CardFooter,
});
